import { ReservationLocalstorageSteps } from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';
import { localStorageValuesFromFirstStep } from 'modules/accommodations/features/reservations/helper';
import {
  useMutationInsertAdditionalDiscountServices,
  useMutationInsertAdditionalServices,
} from 'modules/accommodations/features/reservations/hooks';
import {
  TDiscountTableDataCalculation,
  TServicesTableDataCalculation,
} from 'modules/accommodations/features/reservations/models';

export const useInsertServicesAndDiscountsStepFourAPI = () => {
  const {
    insertAdditionalServicesMutate,
    additionalServicesLoading,
    additionalServicesError,
    additionalServicesData,
  } = useMutationInsertAdditionalServices();

  const {
    insertAdditionalDiscountServicesMutate,
    additionalDiscountServicesLoading,
    additionalDiscountServicesError,
    additionalDiscountServicesData,
  } = useMutationInsertAdditionalDiscountServices();

  const localstorageFirstStep = JSON.parse(
    localStorage.getItem(ReservationLocalstorageSteps.FIRSTSTEP) as string,
  );
  const { languageId } = localStorageValuesFromFirstStep(localstorageFirstStep);

  const insertAdditionalServices = async (
    filteredData: TServicesTableDataCalculation[] | TDiscountTableDataCalculation[],
    reservationId: string,
  ) => {
    await Promise.all(
      filteredData.map(
        async (element: TServicesTableDataCalculation | TDiscountTableDataCalculation) => {
          const payload = {
            ...element,
            reservationLanguageId: languageId,
          } as TServicesTableDataCalculation;

          await insertAdditionalServicesMutate({ reservationId, payload });
        },
      ),
    );
  };

  const insertAdditionalDiscounts = async (
    filteredData: TServicesTableDataCalculation[] | TDiscountTableDataCalculation[],
    reservationId: string,
  ) => {
    await Promise.all(
      filteredData.map(
        async (element: TDiscountTableDataCalculation | TServicesTableDataCalculation) => {
          const payload = {
            ...element,
            reservationLanguageId: languageId,
          } as TDiscountTableDataCalculation;

          await insertAdditionalDiscountServicesMutate({ reservationId, payload });
        },
      ),
    );
  };

  return {
    insertAdditionalServices,
    additionalServicesLoading,
    additionalServicesError,
    additionalServicesData,
    insertAdditionalDiscounts,
    additionalDiscountServicesLoading,
    additionalDiscountServicesError,
    additionalDiscountServicesData,
  };
};
